import React, { Component } from 'react'
import ReactPaginate from 'react-paginate'
import { Link } from 'react-router-dom'
import Severity from '../components/Severity'
import Error from '../components/Error'
import NotAuthorized from '../components/NotAuthorized'
import * as apiCalls from '../lib/apiCalls'
import Modal from '../components/Modal'
import Notify from './Notify'
import InlineLoader from '../components/InlineLoader'
import Loader from '../components/Loader'
import Dropdown from '../components/Dropdown'
import Footer from '../Footer'
import Tooltip from 'rc-tooltip';
import { LanguageContext, LanguageConsumer } from '../lib/LanguageContext'
import './Record.css'


class Record extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
            notAuthorized: false,
            transition: true,
            seeValues : true,
            notify: true,
            notifyModalIsOpen: false,
            dataModalIsOpen: false,
            recordFetched: false,
            recordLoading: 0,
            isNotifiedFetched: false,
            isNotifiedLoading: 0,
            sortingList: [],
            sortingActive: {
              id: 'errorCode-hl',
              order: 'hl',
              property: 'errorCode'
            },
            record: {
                errors: [],
                validMobilePhone: true
            },
            selectorActive: false,
            table: {
                maxRows: 5,
                currentStart: 0,
                currentEnd: 0,
                pageCount: 0
            },
        }
    }

    handlePageClick = (data) => {
        let resultsLen = this.state.record.errors.length;
        let selected = data.selected;
        let offset = selected * this.state.table.maxRows;
        let restRows = resultsLen-offset;
        let currentEnd = restRows > this.state.table.maxRows ? offset + this.state.table.maxRows : resultsLen;
        this.setState(prevState => ({
            ...prevState,
            table : {
                ...prevState.table,
                currentStart: offset,
                currentEnd: currentEnd
            }
        }))
    }

    dataFetched(res) {
        if(res === 403) {
            this.setState({notAuthorized: true})
        } else if(res === 500 || 'error' in res) {
            this.setState({error: true})
        } else {
            return true
        }
        return false
    }

    closeModal = () => {
        this.setState(prevState => ({
            ...prevState,
            notifyModalIsOpen: false
        }))
        
        this.props.handleModal(false)
    }

    closeDataModal = () => {
        this.setState(prevState => ({
            ...prevState,
            dataModalIsOpen: false
        }))
        this.props.handleModal(false)
    }

    afterOpenModal = () => {
       
    }

    handleData = () => {
        this.setState({dataModalIsOpen: true})
    }

    handleNotify = () => {
        this.setState(prevState => ({
            ...prevState,
            notifyModalIsOpen: true
        }))
        this.props.handleModal(true)
    }

    selectorToggle = () => {
        this.props.handleDropdown(!this.state.selectorActive)
        this.setState(prevState => ({
            ...prevState,
            selectorActive: !prevState.selectorActive
        }))
    }

    selectorClose = () => {
        this.props.handleDropdown(false);
        this.setState(prevState => ({
            ...prevState,
            selectorActive: false
        }))
    }

    selectorHandleChange = (active) => {
        this.setState(prevState => ({
            ...prevState,
            sortingActive: active
        }))
        setTimeout(() => {
            this.setState(prevState => ({
                ...prevState,
                selectorActive: false
            }));
            this.props.handleDropdown(false);
        }, 500) 
    }

    formatDate = (date) => {
        let newDate = date
        if(date && date.length === 8 && /^[\d]+$/.test(date)) {
            newDate = date.substring(0, 4) + '-' + date.substring(4, 6) + '-' + date.substring(6, 8)
        }
       return newDate
    }

    handleScroll = (event) => {
        let topBackLink = document.querySelector('#top-back-link')
        if(topBackLink) {
            let rect = topBackLink.getBoundingClientRect();
            let elemTop = rect.top
            let elemBottom = rect.bottom
            if (elemTop < 0) {
                this.setState({secondBackLink: true})
            } else {
                this.setState({secondBackLink: false})
            }
        }
    }

    updateNotified = async () => {
        let recordId = this.props.params.record
        let record = this.state.record
        let isNotifiedLoading = this.state.isNotifiedLoading - 1
        this.setState({ isNotifiedFetched: false })
        let res = await apiCalls.isUserNotifiedSMS(recordId)
        let isNotified = res.notified
        record = {...record, isNotified}
        this.setState({
            isNotifiedLoading: isNotifiedLoading + 1,
            isNotifiedFetched: true,
            record
        })
    }


    recordsWithErrorsInit = async () => {
        let recordId = this.props.params.record
        let recordLoading = this.state.recordLoading - 1
        let isNotifiedLoading = this.state.isNotifiedLoading - 1
        let sortingList = this.props.sortingSelection.map(sel => {return {...sel, display: this.context.polyglot.t(`Dropdown.sortingErrors.${sel.id}`)}})
        this.setState({recordLoading, sortingList})
        let res = await apiCalls.institutionHasSMSService()
        let notify = res.institutionExists

        let record = await apiCalls.recordWithErrors(recordId)
        this.setState({ notify })
        if(this.dataFetched(record)) {

            if(notify) {
                res = await apiCalls.isMobilePhoneValid(recordId)
                let validMobilePhone = res.mobilePhoneValid
                res = await apiCalls.isUserNotifiedSMS(recordId)
                let isNotified = res.notified
                
                record = {...record, validMobilePhone, isNotified}
            }

            let resultsLen = record.errors.length;
            let currentEnd = resultsLen >= this.state.table.maxRows ? this.state.table.maxRows : resultsLen;
            let pageCount = Math.floor(resultsLen / this.state.table.maxRows);
            let sortingActive = this.props.sortingSelection[0]
            pageCount = resultsLen % this.state.table.maxRows ? (pageCount + 1) : pageCount;
            this.setState(prevState => ({
                ...prevState,
                record,
                sortingActive,
                recordLoading: recordLoading + 1,
                recordFetched: true,
                isNotifiedLoading: isNotifiedLoading + 1,
                isNotifiedFetched: true,
                table: {
                    ...prevState.table,
                    currentEnd: currentEnd,
                    pageCount
                }
            }))
        }
    }

        
    componentDidMount = async () => {
        document.title = this.context.polyglot.t('resultsPageTitle');
        let content = document.getElementById('content');
        if (content) {
            content.addEventListener('scroll', this.handleScroll)
            content.scrollTo(0, 0)
        }
        setTimeout(() => {
            this.setState(prevState => ({
                ...prevState,
                transition: false
            }));
        }, 10)
        this.recordsWithErrorsInit()
    }

    componentWillUnmount = () => {
        let content = document.getElementById('content');
        if(content) {
            content.removeEventListener('scroll', this.handleScroll)
        }
    }


    render() {
    
        let parentQueryStr = !this.props.location || !this.props.location.parentQueryStr 
                            ?  '' : this.props.location.parentQueryStr;
        let sortingProperty = this.state.sortingActive.property
        let maxSeverity = 23
        let rows =  this.state.record.errors
                    .sort((a,b) => {
                        if(sortingProperty === 'errorType') {
                            let aProperty = this.context.polyglot.t(`errorsType.${a[sortingProperty]}`) 
                            let bProperty = this.context.polyglot.t(`errorsType.${b[sortingProperty]}`) 
                            return this.state.sortingActive.order === 'hl' ?
                                aProperty < bProperty
                                :   aProperty > bProperty
                        } else {
                            return this.state.sortingActive.order === 'hl' ?
                                a[sortingProperty] < b[sortingProperty]
                             :  a[sortingProperty] > b[sortingProperty] 
                            }
                    })
                    .slice(this.state.table.currentStart, this.state.table.currentEnd);

        let birthDate = this.formatDate(this.state.record.birthDate)
        let enrollmentStatusDate = this.formatDate(this.state.record.enrollmentStatusDate)
        let showNotify = this.state.isNotifiedFetched && this.state.isNotifiedLoading === 0

        if(this.state.error) {
            return (<Error/>)
        } else if(this.state.notAuthorized) {
            return (<NotAuthorized handleLogout={this.props.handleLogout}/>)
        }

        return(
         <LanguageConsumer>
            {({polyglot}) =>
                (<div className={`Record ${this.state.transition ? 'transition' : ''}`}>
                    <div className='back' id='top-back-link'>
                        <Link to={`/results${parentQueryStr}`}><i className="far fa-arrow-alt-circle-left"></i> {polyglot.t('Record.backToResults')}</Link>
                    </div>
                    <div className='header-info'>
                            <h2 className='record-header'><span className="fas fa-user-tag"></span> {polyglot.t('recordInfo')}</h2>
                            <div className='info-wrapper'>
                                <div className='Record-recordInfo'>
                                    <span>{polyglot.t('Record.fields.systemID')}: 
                                        {this.state.recordFetched &&
                                         this.state.recordLoading === 0 ? (
                                            <span className='infoValue'>{this.state.record.systemID}</span>
                                         ) : (
                                             <InlineLoader/>
                                         )}
                                    </span>,
                                    <span> {polyglot.t('Record.fields.registrationID')}: 
                                        {this.state.recordFetched &&
                                         this.state.recordLoading === 0 ? (
                                            <span className='infoValue'>{this.state.record.registrationID}</span>
                                         ) : (
                                             <InlineLoader/>
                                         )}
                                    </span> 
                                </div>
                                <div className='Record-recordInfo'>
                                    {polyglot.t('Record.department')}: 
                                    {this.state.recordFetched &&
                                     this.state.recordLoading === 0 ? (
                                        <span className='infoValue'>{this.state.record.departmentEl}</span>
                                      ) : (
                                          <InlineLoader/>
                                      )}
                               </div>
                               <div className='Record-recordInfo'>
                                   {polyglot.t('Record.severity')}: 
                                   {this.state.recordFetched &&
                                    this.state.recordLoading === 0 ? (
                                        <span className='infoValue'>
                                            <Severity classId={this.state.record.severityGroup} displayString/> ({this.state.record.severity})
                                       </span>
                                    ) : (
                                        <InlineLoader/>
                                    )}
                                </div>
                                <div className='Record-recordInfo'>
                                    {polyglot.t('Record.name')}: 
                                    {this.state.recordFetched &&
                                     this.state.recordLoading === 0 ? (
                                        <span className='infoValue'>
                                            {this.state.record.lastNameEl ? this.state.record.lastNameEl : '-'} {this.state.record.firstNameEl ? this.state.record.firstNameEl : '-' } / {this.state.record.lastNameEn ? this.state.record.lastNameEn : '-'} {this.state.record.firstNameEn ? this.state.record.firstNameEn : '-'}
                                        </span>
                                     ) : (
                                         <InlineLoader/>
                                    )}
                                    </div>
                                <button className='more-data' onClick={this.handleData}>{polyglot.t('Record.moreData')}</button>
                                <Modal  isOpen={this.state.dataModalIsOpen}
                                        onAfterOpen={this.afterOpenModal}
                                        onRequestClose={this.closeDataModal}
                                        className= 'scroll-modal'
                                        contentLabel="Example Modal"
                                >
                                     <div className="closeModal" onClick={this.closeDataModal}>
                                             <div id='x-icon'>
                                                  <span />
                                                  <span />
                                                  <span />
                                                  <span />
                                              </div>
                                          </div>
                                     <div className='record-view-data'>
                                         <div className='content'>
                                             <div className='content-header'>
                                                 <h2 className='header'>
                                                     <span className='far fa-user'></span> {polyglot.t('Record.moreRecordData')}
                                                </h2>
                                            </div>
                                            <div className='extra-info'>
                                            <div className='Record-recordInfo'>
                                                <h4 className='info-heading'>{polyglot.t('Record.names')}</h4>
                                                <div className='fields'>
                                                    <span> {polyglot.t('Record.fields.lastNameEl')}: <span className='infoValue'>
                                                            {this.state.record.lastNameEl ? this.state.record.lastNameEl : '-' }
                                                    </span></span>
                                                    <span> {polyglot.t('Record.fields.lastNameEn')}: <span className='infoValue'>
                                                            {this.state.record.lastNameEn ? this.state.record.lastNameEn : '-'}
                                                    </span></span>
                                                    <span> {polyglot.t('Record.fields.firstNameEl')}: <span className='infoValue'>
                                                            {this.state.record.firstNameEl ? this.state.record.firstNameEl : '-'}
                                                    </span></span>
                                                    <span> {polyglot.t('Record.fields.firstNameEn')} : <span className='infoValue'>
                                                            {this.state.record.firstNameEn ? this.state.record.firstNameEn : '-'}
                                                    </span></span>
                                                    <span> {polyglot.t('Record.fields.fatherFirstNameEl')}: <span className='infoValue'>
                                                            {this.state.record.fatherFirstNameEl ? this.state.record.fatherFirstNameEl : '-'}
                                                    </span></span>
                                                    <span> {polyglot.t('Record.fields.fatherFirstNameEn')}: <span className='infoValue'>
                                                            {this.state.record.fatherFirstNameEn ? this.state.record.fatherFirstNameEn : '-'}
                                                    </span></span>
                                                    <span> {polyglot.t('Record.fields.motherFirstNameEl')}: <span className='infoValue'>
                                                            {this.state.record.motherFirstNameEl ? this.state.record.motherFirstNameEl : '-'}
                                                    </span></span>
                                                    <span> {polyglot.t('Record.fields.motherFirstNameEn')}: <span className='infoValue'>
                                                            {this.state.record.motherFirstNameEn ? this.state.record.motherFirstNameEn : '-'}
                                                    </span></span>
                                                </div>
                                           </div>
                                           <div className='Record-recordInfo'>
                                                <h4 className='info-heading'>{polyglot.t('Record.personalInfo')}</h4>
                                                <div className='fields'>
                                                    <span> {polyglot.t('Record.fields.birthDate')}: <span className='infoValue'>
                                                            {birthDate ? birthDate : '-'}
                                                    </span></span>
                                                    <span> {polyglot.t('Record.fields.birthYear')}: <span className='infoValue'>
                                                            {this.state.record.birthYear ? this.state.record.birthYear : '-'}
                                                    </span></span>
                                                    <span> {polyglot.t('Record.fields.gender')}: <span className='infoValue'>
                                                            {this.state.record.gender ? this.state.record.gender : '-'}
                                                    </span></span>
                                                    <span> {polyglot.t('Record.fields.citizenship')}: <span className='infoValue'>
                                                            {this.state.record.citizenship ? this.state.record.citizenship : '-'}
                                                    </span></span>
                                                </div>
                                          </div>
                                          <div className='Record-recordInfo'>
                                                <h4 className='info-heading'>{polyglot.t('Record.identifiers')}</h4>
                                                <div className='fields'>
                                                    <span> {polyglot.t('Record.fields.ssn')}: <span className='infoValue'>
                                                            {this.state.record.ssn ? this.state.record.ssn : '-'}
                                                    </span></span>
                                                    <span> {polyglot.t('Record.fields.ssnCountry')}: <span className='infoValue'>
                                                            {this.state.record.ssnCountry ? this.state.record.ssnCountry : '-'}
                                                    </span></span>
                                                    <span> {polyglot.t('Record.fields.tin')}: <span className='infoValue'>
                                                            {this.state.record.tin ? this.state.record.tin : '-'}
                                                    </span></span>
                                                    <span> {polyglot.t('Record.fields.tinCountry')}: <span className='infoValue'>
                                                            {this.state.record.tinCountry ? this.state.record.tinCountry : '-'} 
                                                    </span></span>
                                                </div>
                                          </div>
                                          <div className='Record-recordInfo'>
                                                <h4 className='info-heading'>{polyglot.t('Record.studies')}</h4>
                                                <div className='fields'>
                                                    <span> {polyglot.t('Record.fields.enrollmentType')}: <span className='infoValue'>
                                                            {this.state.record.enrollmentType ? this.state.record.enrollmentType : '-'}
                                                    </span></span>
                                                    <span> {polyglot.t('Record.fields.enrollmentStatus')}: <span className='infoValue'>
                                                            {this.state.record.enrollmentStatus ? this.state.record.enrollmentStatus : '-'}
                                                    </span></span>
                                                    <span> {polyglot.t('Record.fields.enrollmentStatusDate')}: <span className='infoValue'>
                                                            {enrollmentStatusDate ? enrollmentStatusDate : '-'}
                                                    </span></span>
                                                    <span> {polyglot.t('Record.fields.enrollmentTerm')}: <span className='infoValue'>
                                                            {this.state.record.enrollmentTerm ? this.state.record.enrollmentTerm : '-'}
                                                    </span></span>
                                                </div>
                                         </div>
                                         <div className='Record-recordInfo'>
                                                <h4 className='info-heading'>{polyglot.t('Record.account')}</h4>
                                                <div className='fields'>
                                                    <span> {polyglot.t('Record.fields.loginName')}: <span className='infoValue'>
                                                            {this.state.record.loginName ? this.state.record.loginName : '-'}
                                                    </span></span>
                                                    <span> {polyglot.t('Record.fields.accountStatus')}: <span className='infoValue'>
                                                            {this.state.record.accountStatus ? this.state.record.accountStatus : '-'}
                                                   </span></span>
                                                </div>
                                         </div>
                                         <div className='Record-recordInfo'>
                                                <h4 className='info-heading'>{polyglot.t('Record.contact')}</h4>
                                                <div className='fields'>
                                                    <span> {polyglot.t('Record.fields.extEmail')}: <span className='infoValue'>
                                                            {this.state.record.extEmail ? this.state.record.extEmail : '-'}
                                                    </span></span>
                                                    <span> {polyglot.t('Record.fields.mobilePhone')}: <span className='infoValue'>
                                                            {this.state.record.mobilePhone ? this.state.record.mobilePhone : '-'}
                                                    </span></span>
                                                </div>
                                            </div>
                                            <button className='close' onClick={this.closeDataModal}>{polyglot.t('Record.close')}</button>
                                         </div>
                                        </div>
                                     </div>
                                </Modal>
                            </div>
                            { this.state.notify && (
                                showNotify ?
                                (
                                  this.state.record.validMobilePhone && !this.state.record.isNotified ? (
                                    <React.Fragment>
                                        <button className='notify-button' onClick={this.handleNotify}>{polyglot.t('Record.notify')}</button>
                                    </React.Fragment>
                                  ) :
                                    !this.state.record.validMobilePhone ? (
                                        <Tooltip placement="top" trigger={['hover']} mouseEnterDelay={0.1}
                                                 mouseLeaveDelay={0.1} overlay={<span>{polyglot.t('invalidMobilePhone')}</span>}>
                                                 <button className='notify-button' disabled onClick={this.handleNotify}>{polyglot.t('Record.notify')}</button>
                                        </Tooltip>
                                    ) : (
                                        <Tooltip placement="top" trigger={['hover']} mouseEnterDelay={0.1}
                                                 mouseLeaveDelay={0.1} overlay={<span>{polyglot.t('userAlreadyNotified')}</span>}>
                                                 <button className='notify-button' disabled onClick={this.handleNotify}>{polyglot.t('Record.notify')}</button>
                                        </Tooltip>
                                    )
                                ) : (
                                    <span className='notify-button'>
                                        <InlineLoader/>
                                    </span>
                                ))
                            }
                            { this.state.notify && this.state.record.validMobilePhone && (
                                            <Modal
                                                isOpen={this.state.notifyModalIsOpen}
                                                onAfterOpen={this.afterOpenModal}
                                                onRequestClose={this.closeModal}
                                                className='scroll-modal'
                                                contentLabel='Example Modal'

                                            >
                                                <Notify closeModal={this.closeModal}
                                                        updateNotified={this.updateNotified}
                                                        objectId={this.props.params.record}
                                                        systemId={this.state.record.systemID}
                                                        registrationId={this.state.record.registrationID}
                                                        mobilePhone={this.state.record.mobilePhone}
                                                />
                                            </Modal>
                                     )
                                }
                            </div>
                    <div className='record-content'>
                        <div className='table-wrapper'>
                            <div className={`${!this.state.secondBackLink ? 'hidden' : ''}`} id='second-back-link'>
                                <Link to={`/results${parentQueryStr}`}><i className="far fa-arrow-alt-circle-left"></i> {polyglot.t('Record.backToResults')}</Link>
                            </div>
                            <h3 className='record-header'><span className='fas fa-exclamation-triangle'></span> {polyglot.t('Record.errors')}</h3>
                            <div className='table-info-wrapper'>
                                <span className='filtered-results'>
                                    <h5 className='checks-header'>{polyglot.t('Record.numOfRecordErrors')}</h5>: <span className='errNumber-value'>{rows.length}</span>
                                </span>
                                <div className='sorting'>
                                    <span className='sort-header'>
                                        {polyglot.t('Record.sortBy')}:
                                    </span>
                                    <Dropdown
                                            className='flexible'
                                            name='sorting-errors'
                                            handleChange={this.selectorHandleChange} 
                                            type='single-select' 
                                            list={this.state.sortingList} 
                                            withIcon={true}
                                            active={this.state.selectorActive} toggle={this.selectorToggle} 
                                            close={this.selectorClose}
                                            activeId={this.state.sortingActive.id}
                                            selection={polyglot.t(`Dropdown.sortingErrors.label`)}
                                            translate
                                    />
                               </div>
                            </div>
                            <div className='h-scroll'>
                                <table className={`results-table ${this.state.seeValues ? 'expanded' : ''}`} cellPadding="0" cellSpacing="0"> 
                                    <tbody>
                                        <tr>
                                            <th>
                                                {polyglot.t('errCode')}
                                            </th>
                                            <th>
                                                {polyglot.t('errDescription')}
                                            </th>
                                            <th>
                                                {polyglot.t('errType')}
                                            </th>
                                            <th>
                                                {polyglot.t('errSeverity')}
                                            </th>
                                            <th>
                                                {polyglot.t('errFields')}
                                            </th>
                                            {
                                                this.state.seeValues && (
                                                        <th>{polyglot.t('errValue1')}</th>
                                                )
                                            }
                                                                            {
                                                this.state.seeValues && (
                                                        <th>{polyglot.t('errValue2')}</th>
                                                )
                                            }
                                        </tr>
                                        {this.state.recordFetched &&
                                         this.state.recordLoading === 0 ? (
                                            rows.map(err => 
                                                <tr key={err.errorCode}>
                                                    <td>
                                                        {err.errorCode}
                                                    </td>
                                                    <td className='err-desc'>
                                                        {polyglot.t(`errors.${err.errorCode}`)}
                                                    </td>
                                                    <td>
                                                        {polyglot.t(`errorsType.${err.errorType}`)}
                                                    </td>
                                                    <td className='err-severity'>
                                                        <Severity normalize={true} classId={err.errorSeverity} maxSeverity={maxSeverity} tooltip/>
                                                    </td>
                                                    <td>
                                                        {err.errorFields.map(field => <div key={`${err.errorCode}${field.fieldName}`} className='subCell'>{field.fieldName}</div>)}
                                                    </td>
                                                    {
                                                        this.state.seeValues && (
                                                                <td>
                                                                    {err.errorFields.map((field, i) => 
                                                                    <div key={`${err.errorCode}${field.fieldName}1${i}`} className='subCell'>
                                                                        <span className={`${field.valueGroup1 && field.valueGroup1.value === 'null' ? 'null-value': ''}`}>
                                                                        {
                                                                            field.valueGroup1 && field.valueGroup1.value && field.valueGroup1.value.length !== 0 ? field.valueGroup1.value : '-'
                                                                        }
                                                                        </span>
                                                                    </div>)}
                                                                </td>
                                                        )
                                                    }
                                                    {
                                                        this.state.seeValues && (
                                                                <td>
                                                                    {err.errorFields.map((field, i) => <div key={`${err.errorCode}${field.fieldName}2${i}`} className='subCell'>
                                                                        <span className={`${field.valueGroup2 && field.valueGroup2.value === 'null' ? 'null-value': ''}`}>
                                                                        {
                                                                            field.valueGroup2 && field.valueGroup2.value 
                                                                            && field.valueGroup2.value.length !== 0 ? field.valueGroup2.value : '-'
                                                                        }
                                                                        </span>
                                                                    </div>)}
                                                                </td>
                                                        )
                                                    }
                                                </tr>
                                            )
                                         ) : (
                                             <tr>
                                                 <td colSpan="7">
                                                     <Loader/>
                                                 </td>
                                             </tr>
                                         )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className='pagination-wrapper'>
                            {this.state.recordFetched &&
                             this.state.recordLoading === 0 && (
                                <ReactPaginate previousLabel={"\u3008"}
                                    nextLabel={"\u3009"}
                                    breakLabel={"..."}
                                    breakClassName={"break-me"}
                                    pageCount={this.state.table.pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={3}
                                    onPageChange={this.handlePageClick}
                                    containerClassName={"pagination"}
                                    subContainerClassName={"pages pagination"}
                                    activeClassName={"active"} />
                            )}
                        </div>
                    </div>
                    <Footer/>
                </div>)}
              </LanguageConsumer>
        )
    }
}
Record.contextType = LanguageContext

export default Record




// WEBPACK FOOTER //
// ./src/results/Record.js